import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '@/views/Login.vue'
import Reset from '@/views/Reset.vue'

import Dashboard from '@/views/Dashboard.vue'
import ChangePassword from '@/views/dashboard/ChangePassword.vue'

import Guest from '@/views/dashboard/Guest.vue'

import Manager from '@/views/dashboard/Manager.vue'

import Member from '@/views/dashboard/Member.vue'
import Properties from '@/views/dashboard/member/Properties.vue'
import Property from '@/views/dashboard/member/Property.vue'
import Account from '@/views/dashboard/member/Account.vue'
import Payments from '@/views/dashboard/member/Payments.vue'
import Payment from '@/views/dashboard/member/Payment.vue'
import Rentals from '@/views/dashboard/member/Rentals.vue'
import RentalForm from '@/views/dashboard/member/RentalForm.vue'

import Admin from '@/views/dashboard/Admin.vue'
import EmailCampaign from '@/views/dashboard/admin/EmailCampaign.vue'
import ResendActivation from '@/views/dashboard/admin/ResendActivation.vue'
import ResetLoginAttempts from '@/views/dashboard/admin/ResetLoginAttempts.vue'

import CrudBrowser from '../components/crud-management/CrudBrowser.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: {
      title: `${process.env.VUE_APP_SHORT_TITLE} | Login`
    },
  },
  {
    path: '/reset',
    name: 'Reset',
    component: Reset,
    meta: {
      title: `${process.env.VUE_APP_SHORT_TITLE} | Reset Password`
    },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      title: `${process.env.VUE_APP_SHORT_TITLE} | Dashboard`
    },
    children: [
      {
        path: 'change-password',
        component: ChangePassword,
        meta: {
          title: `${process.env.VUE_APP_SHORT_TITLE} | Change Password`
        },
      },
      {
        path: 'guest',
        component: Guest,
        meta: {
          title: `${process.env.VUE_APP_SHORT_TITLE} | Dashboard`
        },
        children: [

        ],
      },
      {
        path: 'manager',
        component: Manager,
        children: [
          {
            path: 'my-account',
            component: Account,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | My Account`
            },
          },
          {
            path: 'properties',
            component: Properties,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Properties`
            },
          },
          {
            path: 'property/:property_id',
            component: Property,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Property`
            },
          },
          {
            path: 'payments',
            component: Payments,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Payments`
            },
          },
          ,
          {
            path: 'payment',
            component: Payment,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Payment`
            },
          },
          {
            path: 'rentals',
            component: Rentals,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Rentals`
            },
          },
          {
            path: 'rental-form',
            component: RentalForm,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Rental Form`
            },
          },
          {
            path: 'rental-form/:rental_id',
            component: RentalForm,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Rental`
            },
          },
        ]
      },
      {
        path: 'member',
        component: Member,
        children: [
          {
            path: 'properties',
            component: Properties,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Properties`
            },
          },
          {
            path: 'property/:property_id',
            component: Property,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Property`
            },
          },
          {
            path: 'my-account',
            component: Account,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | My Account`
            },
          },
          {
            path: 'rental-form',
            component: RentalForm,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Rental Form`
            },
          },
          {
            path: 'rental-form/:rental_id',
            component: RentalForm,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Rental`
            },
          },
          {
            path: 'payments',
            component: Payments,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Payments`
            },
          },
          ,
          {
            path: 'payment',
            component: Payment,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Payment`
            },
          },
          {
            path: 'rentals',
            component: Rentals,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Rentals`
            },
          },
        ],
      },
      {
        path: 'admin',
        component: Admin,
        meta: {
          title: `${process.env.VUE_APP_SHORT_TITLE} | Admin Dashboard`
        },
        children: [
          {
            path: 'master',
            component: CrudBrowser,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Master`
            },
            props: {
              title: 'Master',
              crudRoute: '/master',
              joinItemsEndpoint: [{ endpoint: '/email_list_x_user/joined-items', mainKeys: ['id'], joinKeys: ['user_id'] }],
              addHeadersEndpoint: ['/email_list/header-list'],
              addTemplateItemsEndpoint: ['/email_list/template-list'],
              headers: [
                { text: 'ID', value: 'id', width: '50px', primaryKey: true },
                { text: 'Lot #', value: 'lot', width: '100px', sortBy: 1, sortDir: 'asc' },
                { text: 'Member of Record', value: 'member_of_record', width: '300px' },
                { text: 'Address Line 1', value: 'line1', width: '200px' },
                { text: 'Address Line 2', value: 'line2', width: '200px' },
                { text: 'City', value: 'city', width: '100px' },
                { text: 'State/Province', value: 'state', width: '100px' },
                { text: 'Country', value: 'country', width: '100px' },
                { text: 'Zip', value: 'zip', width: '100px' },
                { text: 'Discount %', value: 'discount', width: '100px' },
                { text: 'Whatcom Property ID', value: 'property_url', width: '200px' },
                { text: 'Notes', value: 'notes', width: '200px' },
                { text: 'Legal Owner', value: 'legal_owner', width: '300px', align: 'left' },
                { text: 'Last Name', value: 'lname', width: '150px', align: 'left' },
                { text: 'First Name', value: 'fname', width: '150px', align: 'left' },
                { text: 'Permissions', value: 'permissions', width: '100px' },
                { text: 'Email', value: 'email', width: '200px', align: 'left' },
                { text: 'Email #2', value: 'email2', width: '200px', align: 'left' },
                { text: 'Email #3', value: 'email3', width: '200px', align: 'left' },
                { text: 'Phone', value: 'phone', width: '150px' },
                { text: 'Phone #2', value: 'phone2', width: '150px' },
                { text: 'Phone #3', value: 'phone3', width: '150px' },
                { text: 'Mailing Address Line 1', value: 'mailing_line1', width: '200px', align: 'left' },
                { text: 'Mailing Address Line 2', value: 'mailing_line2', width: '200px', align: 'left' },
                { text: 'Mailing City', value: 'mailing_city', width: '100px', align: 'left' },
                { text: 'Mailing State/Province', value: 'mailing_state', width: '100px', align: 'left' },
                { text: 'Mailing Country', value: 'mailing_country', width: '100px', align: 'left' },
                { text: 'Mailing Zip', value: 'mailing_zip', width: '100px', align: 'left' },
                { text: 'License Plates', value: 'license_plates', width: '200px', align: 'left' },
                { text: 'Owner Notes', value: 'owner_notes', width: '200px', align: 'left' },
                { text: 'Activated', value: 'activated', width: '100px' },
                { text: 'Phone Listed', value: 'phone_listed', width: '100px' },
              ],
              itemTemplate: {
                id: {
                  label: 'ID',
                  type: 'number',
                  hidden: true,
                  required: true,
                },
                lot: {
                  label: 'Lot #',
                  type: 'number',
                  required: true,
                },
                member_of_record: {
                  label: 'Member of Record',
                  type: 'autocomplete',
                  itemsEndpoint: '/users/list/member-of-records',
                  required: true,
                },
                line1: {
                  label: 'Address Line 1',
                  type: 'string',
                  required: true,
                },
                line2: {
                  label: 'Address Line 2',
                  type: 'string',
                  required: false,
                },
                city: {
                  label: 'City',
                  type: 'string',
                  default: 'Deming',
                  required: true,
                },
                state: {
                  label: 'State/Province',
                  type: 'string',
                  default: 'WA',
                  required: true,
                },
                country: {
                  label: 'Country',
                  type: 'string',
                  default: 'USA',
                  required: true,
                },
                zip: {
                  label: 'Zip',
                  type: 'string',
                  default: '98244',
                  required: true,
                },
                discount: {
                  label: 'Discount %',
                  type: 'number',
                  required: true,
                  default: 0,
                },
                property_url: {
                  label: 'Whatcom Property ID',
                  type: 'url',
                  url: `https://property.whatcomcounty.us/propertyaccess/Property.aspx?cid=0&year=${new Date().getFullYear()}}&prop_id={{property_url}}`,
                  required: false,
                },
                notes: {
                  label: 'Notes',
                  type: 'textarea',
                  required: false,
                },
                email: {
                  type: 'email',
                  required: true,
                  disabled: {
                    edit: true,
                  },
                },
                email2: {
                  type: 'email',
                  required: false,
                  hidden: {
                    add: true,
                  },
                },
                email3: {
                  type: 'email',
                  required: false,
                  hidden: {
                    add: true,
                  },
                },
                permissions: {
                  type: 'select',
                  items: [
                    { text: 'Admin', value: 8 },
                    { text: 'Member', value: 4 },
                    { text: 'Manager', value: 2 },
                  ],
                  required: true,
                },
                legal_owner: {
                  type: 'string',
                  required: true,
                },
                fname: {
                  type: 'string',
                  required: true,
                },
                lname: {
                  type: 'string',
                  required: true,
                },
                phone: {
                  type: 'tel',
                  required: false,
                  prefix: '+',
                  placeholder: '1 (555) 555-5555',
                  hidden: {
                    add: true,
                  },
                },
                phone2: {
                  type: 'tel',
                  required: false,
                  prefix: '+',
                  placeholder: '1 (555) 555-5555',
                  hidden: {
                    add: true,
                  },
                },
                phone3: {
                  type: 'tel',
                  required: false,
                  prefix: '+',
                  placeholder: '1 (555) 555-5555',
                  hidden: {
                    add: true,
                  },
                },
                mailing_line1: {
                  type: 'string',
                  required: false,
                  hidden: {
                    add: true,
                  },
                },
                mailing_line2: {
                  type: 'string',
                  required: false,
                  hidden: {
                    add: true,
                  },
                },
                mailing_city: {
                  type: 'string',
                  required: false,
                  hidden: {
                    add: true,
                  },
                },
                mailing_state: {
                  type: 'string',
                  required: false,
                  hidden: {
                    add: true,
                  },
                },
                mailing_country: {
                  type: 'combobox',
                  items: [
                    'USA', 'CA',
                  ],
                  defaultValue: 'USA',
                  required: false,
                  hidden: {
                    add: true,
                  },
                },
                mailing_zip: {
                  type: 'string',
                  required: false,
                  hidden: {
                    add: true,
                  },
                },
                license_plates: {
                  type: 'string',
                  required: false,
                  hidden: {
                    add: true,
                  }
                },
                owner_notes: {
                  type: 'textarea',
                  required: false,
                },
                activated: {
                  type: 'switch',
                  hidden: {
                    add: true,
                  },
                  text: {
                    true: 'Yes',
                    false: 'No',
                  }
                },
                phone_listed: {
                  type: 'switch',
                  text: {
                    true: 'Yes',
                    false: 'No',
                  },
                  hidden: {
                    add: true,
                  },
                  disabled: {
                    edit: true,
                  },
                },
              },
              allowDblClickEdit: false,
              allowAdd: false,
              allowEdit: false,
              allowDelete: false,
              allowDownload: true,
              allowCopy: true,
              allowSearch: true,
              allowSort: true,
            },
          },
          {
            path: 'settings',
            component: CrudBrowser,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Settings`
            },
            props: {
              title: 'Settings',
              crudRoute: '/globals',
              headers: [
                { text: 'ID', value: 'id', width: '50px', primaryKey: true },
                { text: 'Name', value: 'display_name', width: '200px', sortBy: 1, sortDir: 'asc' },
                { text: 'Value', value: 'value', width: '200px' },
                { text: 'Units', value: 'units', width: '100px' },
              ],
              itemTemplate: {
                id: {
                  type: 'number',
                  hidden: true,
                },
                display_name: {
                  type: 'string',
                  required: true,
                },
                value: {
                  type: 'string',
                  required: true,
                },
                units: {
                  type: 'string',
                  required: true,
                  disabled: true,
                }
              },
              allowDblClickEdit: false,
              allowAdd: false,
              allowEdit: true,
              allowDelete: false,
              allowDownload: true,
              allowCopy: true,
              allowSearch: true,
              allowSort: true,
            },
          },
          {
            path: 'manage-users',
            component: CrudBrowser,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Users`
            },
            props: {
              title: 'Users',
              crudRoute: '/users',
              joinItemsEndpoint: [{ endpoint: '/email_list_x_user/joined-items', mainKeys: ['id'], joinKeys: ['user_id'] }],
              addHeadersEndpoint: ['/email_list/header-list'],
              addTemplateItemsEndpoint: ['/email_list/template-list'],
              headers: [
                { text: 'ID', value: 'id', width: '50px', primaryKey: true },
                { text: 'Legal Owner', value: 'legal_owner', width: '300px', align: 'left', sortBy: 1, sortDir: 'asc' },
                { text: 'Last Name', value: 'lname', width: '150px', align: 'left' },
                { text: 'First Name', value: 'fname', width: '150px', align: 'left' },
                { text: 'Permissions', value: 'permissions', width: '100px' },
                { text: 'Email', value: 'email', width: '200px', align: 'left' },
                { text: 'Email #2', value: 'email2', width: '200px', align: 'left' },
                { text: 'Email #3', value: 'email3', width: '200px', align: 'left' },
                { text: 'Phone', value: 'phone', width: '150px' },
                { text: 'Phone #2', value: 'phone2', width: '150px' },
                { text: 'Phone #3', value: 'phone3', width: '150px' },
                { text: 'Mailing Address Line 1', value: 'mailing_line1', width: '200px', align: 'left' },
                { text: 'Mailing Address Line 2', value: 'mailing_line2', width: '200px', align: 'left' },
                { text: 'Mailing City', value: 'mailing_city', width: '100px', align: 'left' },
                { text: 'Mailing State/Province', value: 'mailing_state', width: '100px', align: 'left' },
                { text: 'Mailing Country', value: 'mailing_country', width: '100px', align: 'left' },
                { text: 'Mailing Zip', value: 'mailing_zip', width: '100px', align: 'left' },
                { text: 'License Plates', value: 'license_plates', width: '200px', align: 'left' },
                { text: 'Owner Notes', value: 'owner_notes', width: '200px', align: 'left' },
                { text: 'Activated', value: 'activated', width: '100px', align: 'center' },
                { text: 'Phone Listed', value: 'phone_listed', width: '100px', align: 'center' },
              ],
              itemTemplate: {
                id: {
                  type: 'number',
                  hidden: true,
                  required: true,
                },
                email: {
                  type: 'email',
                  required: true,
                  disabled: {
                    edit: true,
                  },
                },
                email2: {
                  type: 'email',
                  required: false,
                  hidden: {
                    add: true,
                  },
                },
                email3: {
                  type: 'email',
                  required: false,
                  hidden: {
                    add: true,
                  },
                },
                permissions: {
                  type: 'autocomplete',
                  items: [
                    { text: 'Admin', value: 8 },
                    { text: 'Member', value: 4 },
                    { text: 'Manager', value: 2 },
                  ],
                  required: true,
                },
                legal_owner: {
                  type: 'string',
                  required: true,
                },
                fname: {
                  type: 'string',
                  required: true,
                },
                lname: {
                  type: 'string',
                  required: true,
                },
                phone: {
                  type: 'tel',
                  required: false,
                  prefix: '+',
                  placeholder: '1 (555) 555-5555',
                  hidden: {
                    add: true,
                  },
                },
                phone2: {
                  type: 'tel',
                  required: false,
                  prefix: '+',
                  placeholder: '1 (555) 555-5555',
                  hidden: {
                    add: true,
                  },
                },
                phone3: {
                  type: 'tel',
                  required: false,
                  prefix: '+',
                  placeholder: '1 (555) 555-5555',
                  hidden: {
                    add: true,
                  },
                },
                mailing_line1: {
                  type: 'string',
                  required: false,
                  hidden: {
                    add: true,
                  },
                },
                mailing_line2: {
                  type: 'string',
                  required: false,
                  hidden: {
                    add: true,
                  },
                },
                mailing_city: {
                  type: 'string',
                  required: false,
                  hidden: {
                    add: true,
                  },
                },
                mailing_state: {
                  type: 'string',
                  required: false,
                  hidden: {
                    add: true,
                  },
                },
                mailing_country: {
                  type: 'combobox',
                  items: [
                    'USA', 'CA',
                  ],
                  defaultValue: 'USA',
                  required: false,
                  hidden: {
                    add: true,
                  },
                },
                mailing_zip: {
                  type: 'string',
                  required: false,
                  hidden: {
                    add: true,
                  },
                },
                license_plates: {
                  type: 'string',
                  required: false,
                  hidden: {
                    add: true,
                  }
                },
                owner_notes: {
                  type: 'textarea',
                  required: false,
                },
                activated: {
                  type: 'switch',
                  hidden: {
                    add: true,
                  },
                  text: {
                    true: 'Yes',
                    false: 'No',
                  }
                },
                phone_listed: {
                  type: 'switch',
                  text: {
                    true: 'Yes',
                    false: 'No',
                  },
                  hidden: {
                    add: true,
                  },
                  disabled: true,
                },
              },
              allowDblClickEdit: false,
              allowAdd: true,
              allowEdit: true,
              allowDelete: true,
              allowDownload: true,
              allowCopy: true,
              allowSearch: true,
              allowSort: true,
            },
          },
          {
            path: 'manage-properties',
            component: CrudBrowser,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Properties`
            },
            props: {
              title: 'Properties',
              crudRoute: '/properties',
              headers: [
                { text: 'ID', value: 'id', width: '50px', primaryKey: true },
                { text: 'Lot #', value: 'lot', width: '100px', sortBy: 1, sortDir: 'asc' },
                { text: 'Member of Record', value: 'member_of_record', width: '300px', align: 'left' },
                { text: 'Address Line 1', value: 'line1', width: '200px' },
                { text: 'Address Line 2', value: 'line2', width: '200px' },
                { text: 'City', value: 'city', width: '100px' },
                { text: 'State/Province', value: 'state', width: '100px' },
                { text: 'Country', value: 'country', width: '100px' },
                { text: 'Zip', value: 'zip', width: '100px' },
                { text: 'Discount %', value: 'discount', width: '100px' },
                { text: 'Whatcom Property ID', value: 'property_url', width: '200px' },
                { text: 'Notes', value: 'notes', width: '200px' },
              ],
              itemTemplate: {
                id: {
                  type: 'number',
                  hidden: true,
                  required: true,
                },
                lot: {
                  type: 'number',
                  required: true,
                },
                member_of_record: {
                  type: 'autocomplete',
                  itemsEndpoint: '/users/list/member-of-records',
                  required: true,
                },
                line1: {
                  type: 'string',
                  required: true,
                },
                line2: {
                  type: 'string',
                  required: false,
                },
                city: {
                  type: 'string',
                  default: 'Deming',
                  required: true,
                },
                state: {
                  type: 'string',
                  default: 'WA',
                  required: true,
                },
                country: {
                  type: 'string',
                  default: 'USA',
                  required: true,
                },
                zip: {
                  type: 'string',
                  default: '98244',
                  required: true,
                },
                discount: {
                  type: 'number',
                  required: true,
                  default: 0,
                  rules: [
                    v => v >= 0 && v <= 100 || 'Discount must be between 0% and 100%',
                  ]
                },
                property_url: {
                  type: 'url',
                  url: `https://property.whatcomcounty.us/propertyaccess/Property.aspx?cid=0&year=${new Date().getFullYear()}}&prop_id={{property_url}}`,
                  required: false,
                },
                notes: {
                  type: 'textarea',
                  required: false,
                }
              },
              allowDblClickEdit: false,
              allowAdd: true,
              allowEdit: true,
              allowDelete: true,
              allowDownload: true,
              allowCopy: true,
              allowSearch: true,
              allowSort: true,
            },
          },
          {
            path: 'manage-violations',
            component: CrudBrowser,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Violations`
            },
            props: {
              title: 'Violations',
              crudRoute: '/violations',
              headers: [
                { text: 'ID', value: 'id', width: '50px', primaryKey: true },
                { text: 'Lot #', value: 'property_id', width: '100px' },
                { text: 'Date of Violation', value: 'date_of', width: '100px', sortBy: 1, sortDir: 'desc' },
                { text: 'Topic', value: 'topic', width: '200px' },
                { text: 'Description', value: 'description', width: '400px' },
                { text: 'Amount', value: 'amount', width: '100px' },
                { text: 'Accrue Interest', value: 'accrue_interest', width: '100px' },
                { text: 'Payment ID', value: 'payment_id', width: '100px' },
                { text: 'Payment Type', value: 'payment_type', width: '100px' },
                { text: 'Payment Date', value: 'payment_date', width: '190px' },
                { text: 'PayPal Confirm', value: 'paypal_confirm', width: '100px' },
              ],
              itemTemplate: {
                id: {
                  type: 'number',
                  hidden: true,
                  required: true,
                },
                property_id: {
                  type: 'autocomplete',
                  itemsEndpoint: '/properties/list',
                  required: true,
                },
                date_of: {
                  type: 'date',
                  required: true,
                },
                topic: {
                  type: 'text',
                  required: true,
                },
                description: {
                  type: 'textarea',
                  required: false,
                },
                amount: {
                  type: 'number',
                  step: '0.01',
                  prefix: '$',
                  required: true,
                },
                accrue_interest: {
                  type: 'switch',
                  required: true,
                  prefill: true,
                },
                payment_id: {
                  type: 'number',
                  required: false,
                  hidden: true,
                },
                payment_type: {
                  type: 'string',
                },
                payment_date: {
                  type: 'datetime-local',
                },
                paypal_confirm: {
                  type: 'string',
                },
              }
            },
          },
          {
            path: 'manage-dues',
            component: CrudBrowser,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Dues`
            },
            props: {
              title: 'Dues',
              crudRoute: '/dues',
              headers: [
                { text: 'ID', value: 'id', width: '50px', primaryKey: true, sortBy: 1, sortDir: 'desc' },
                { text: 'Name', value: 'name', width: '200px' },
                { text: 'Amount', value: 'amount', width: '100px' },
                { text: 'Due Date', value: 'due_date', width: '100px' },
              ],
              itemTemplate: {
                id: {
                  label: 'ID',
                  type: 'number',
                  hidden: true,
                  required: true,
                },
                name: {
                  label: 'Name',
                  type: 'text',
                  required: true,
                },
                amount: {
                  label: 'Amount',
                  type: 'number',
                  step: '0.01',
                  prefix: '$',
                  required: true,
                },
                due_date: {
                  label: 'Due Date',
                  type: 'date',
                  required: true,
                },
              },
              allowDblClickEdit: false,
              allowAdd: true,
              allowEdit: true,
              allowDelete: true,
              allowDownload: true,
              allowCopy: true,
              allowSearch: true,
              allowSort: true,
            },
          },
          {
            path: 'manage-alerts',
            component: CrudBrowser,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Alerts`
            },
            props: {
              title: 'Alerts',
              crudRoute: '/alerts',
              headers: [
                { text: 'ID', value: 'id', width: '50px', primaryKey: true, sortBy: 1, sortDir: 'desc' },
                { text: 'Start Date', value: 'start_date', width: '100px' },
                { text: 'End Date', value: 'end_date', width: '100px' },
                { text: 'Alert', value: 'topic', width: '200px', align: 'left' },
                { text: 'Description', value: 'description', width: '400px', align: 'left' },
              ],
              itemTemplate: {
                id: {
                  type: 'number',
                  hidden: true,
                  required: true,
                },
                start_date: {
                  type: 'date',
                  required: true,
                },
                end_date: {
                  type: 'date',
                  required: true,
                },
                topic: {
                  type: 'string',
                  required: true,
                },
                description: {
                  type: 'textarea',
                  required: true,
                },
              },
              allowDblClickEdit: false,
              allowAdd: true,
              allowEdit: true,
              allowDelete: true,
              allowDownload: true,
              allowCopy: true,
              allowSearch: true,
              allowSort: true,
            },
          },
          {
            path: 'manage-rentals',
            component: CrudBrowser,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Rentals`
            },
            props: {
              title: 'Rentals',
              crudRoute: '/rentals',
              headers: [
                { text: 'ID', value: 'id', width: '50px', primaryKey: true },
                { text: 'Property', value: 'property_id', width: '300px', align: 'left' },
                { text: 'Check In', value: 'check_in', width: '100px', sortBy: 1, sortDir: 'desc' },
                { text: 'Check Out', value: 'check_out', width: '100px', sortBy: 2, sortDir: 'desc' },
                { text: 'Amount', value: 'amount', width: '50px' },
                { text: 'Due Date', value: 'due_date', width: '100px' },
                { text: 'Non-Paying', value: 'f_and_f', width: '50px' },
                { text: 'Guests', value: 'guests', width: '150px' },
                { text: 'Vehicles', value: 'vehicles', width: '300px' },
                { text: 'Payment ID', value: 'payment_id', width: '50px' },
                { text: 'Payment Type', value: 'payment_type', width: '100px' },
                { text: 'Payment Date', value: 'payment_date', width: '190px' },
                { text: 'Paypal Confirm', value: 'paypal_confirm', width: '100px' },
              ],
              itemTemplate: {
                id: {
                  type: 'number',
                  hidden: true,
                  required: true,
                },
                property_id: {
                  type: 'autocomplete',
                  itemsEndpoint: '/properties/list',
                  required: true,
                  disabled: {
                    edit: true,
                  }
                },
                check_in: {
                  type: 'date',
                  required: true,
                },
                check_out: {
                  type: 'date',
                  required: true,
                },
                amount: {
                  type: 'number',
                  hideArrows: true,
                  step: '0.01',
                  prefix: '$',
                  required: true,
                },
                due_date: {
                  type: 'date',
                  hidden: true,
                  required: true,
                },
                f_and_f: {
                  type: 'switch',
                  text: {
                    true: 'Yes',
                    false: 'No',
                  },
                  required: true,
                },
                guests: {
                  type: 'list',
                  template: {
                    fname: {
                      label: 'First name',
                    },
                    lname: {
                      label: 'Last name',
                    }
                  },
                  min: 1,
                },
                vehicles: {
                  type: 'list',
                  template: {
                    make: {
                      label: 'Make',
                    },
                    model: {
                      label: 'Model',
                    },
                    license_plate: {
                      label: 'License Plate',
                    },
                    region: {
                      label: 'State/Province',
                    }
                  },
                  min: 1,
                },
                payment_id: {
                  type: 'number',
                  required: false,
                  hidden: true,
                },
                payment_type: {
                  type: 'select',
                  items: [
                    {
                      text: 'Paypal',
                      value: 'PAYPAL',
                    },
                    {
                      text: 'Check',
                      value: 'CHECK',
                    },
                    {
                      text: 'Cash',
                      value: 'CASH',
                    }
                  ],
                  required: false,
                },
                payment_date: {
                  type: 'datetime-local',
                  required: false,
                },
                paypal_confirm: {
                  type: 'string',
                  required: false,
                },
              },
              allowDblClickEdit: false,
              allowAdd: false,
              allowEdit: true,
              allowDelete: true,
              allowDownload: true,
              allowCopy: true,
              allowSearch: true,
              allowSort: true,
            },
          },
          {
            path: 'manage-payments',
            component: CrudBrowser,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Payments`
            },
            props: {
              title: 'Payments',
              crudRoute: '/payments',
              headers: [
                { text: 'ID', value: 'id', width: '50px', primaryKey: true },
                { text: 'Paid By', value: 'paid_by_name', width: '200px' },
                { text: 'Email', value: 'paid_by_email', width: '200px' },
                { text: 'Type', value: 'payment_type', width: '100px' },
                { text: 'Payment Date', value: 'payment_date', width: '100px', sortBy: 1, sortDir: 'desc' },
                { text: 'Amount', value: 'amount', width: '100px' },
                { text: 'PayPal Confirm', value: 'paypal_confirm', width: '100px' },
              ],
              itemTemplate: {
                id: {
                  label: 'ID',
                  type: 'number',
                  hidden: true,
                },
                paid_by_name: {
                  label: 'Paid Name',
                  type: 'string',
                },
                paid_by_email: {
                  label: 'Paid Email',
                  type: 'email',
                },
                payment_type: {
                  label: 'Type',
                  type: 'string',
                },
                payment_date: {
                  label: 'Payment Date',
                  type: 'datetime-local',
                },
                amount: {
                  label: 'Amount',
                  type: 'number',
                },
                paypal_confirm: {
                  label: 'PayPal Confirm',
                  type: 'string',
                },
              },
              allowDblClickEdit: false,
              allowAdd: true,
              allowEdit: false,
              allowDelete: true,
              allowDownload: true,
              allowCopy: true,
              allowSearch: true,
              allowSort: true,
            },
          },
          {
            path: 'manage-property-dues',
            component: CrudBrowser,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Property Dues`
            },
            props: {
              title: 'Property Dues',
              crudRoute: '/properties_x_dues',
              headers: [
                { text: 'Property', value: 'property_id', width: '300px', primaryKey: true,  sortBy: 1, sortDir: 'asc' },
                { text: 'Due', value: 'due_id', width: '100px', primaryKey: true, sortBy: 2, sortDir: 'desc' },
                { text: 'Payment ID', value: 'payment_id', width: '100px' },
                { text: 'Payment Type', value: 'payment_type', width: '100px' },
                { text: 'Payment Date', value: 'payment_date', width: '190px' },
                { text: 'Paypal Confirm', value: 'paypal_confirm', width: '100px' },
              ],
              itemTemplate: {
                property_id: {
                  type: 'autocomplete',
                  itemsEndpoint: '/properties/list',
                  required: true,
                  disabled: {
                    edit: true,
                  }
                },
                due_id: {
                  type: 'autocomplete',
                  itemsEndpoint: '/dues/list',
                  required: true,
                  disabled: {
                    edit: true,
                  }
                },
                payment_id: {
                  type: 'number',
                  required: false,
                  hidden: true,
                },
                payment_type: {
                  type: 'select',
                  items: [
                    {
                      text: 'PAYPAL',
                      value: 'PAYPAL',
                    },
                    {
                      text: 'CHECK',
                      value: 'CHECK',
                    },
                    {
                      text: 'CASH',
                      value: 'CASH',
                    }
                  ]
                },
                payment_date: {
                  type: 'datetime-local',
                  required: false,
                },
                paypal_confirm: {
                  type: 'string',
                  required: false,
                  depends: {
                    payment_type: 'PAYPAL',
                  }
                },
              },
              allowDblClickEdit: false,
              allowAdd: true,
              allowEdit: true,
              allowDelete: true,
              allowDownload: true,
              allowCopy: true,
              allowSearch: true,
              allowSort: true,
            },
          },
          {
            path: 'manage-property-managers',
            component: CrudBrowser,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Property Managers`
            },
            props: {
              title: 'Property Managers',
              crudRoute: '/users_x_properties',
              headers: [
                { text: 'Property', value: 'property_id', width: '300px', align: 'left', primaryKey: true, sortBy: 1, sortDir: 'asc' },
                { text: 'Manager', value: 'user_id', width: '300px', align: 'left', primaryKey: true, sortBy: 2, sortDir: 'asc' },
              ],
              itemTemplate: {
                property_id: {
                  label: 'Lot #',
                  type: 'autocomplete',
                  itemsEndpoint: '/properties/list',
                },
                user_id: {
                  label: 'Manager',
                  type: 'autocomplete',
                  itemsEndpoint: '/users/list/managers',
                },
              },
              allowDblClickEdit: false,
              allowAdd: true,
              allowEdit: true,
              allowDelete: true,
              allowDownload: true,
              allowCopy: true,
              allowSearch: true,
              allowSort: true,
            },
          },
          {
            path: 'members-owe',
            component: CrudBrowser,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Members Owe`
            },
            props: {
              title: 'Members Owe',
              crudRoute: '/users/members_owe',
              headers: [
                { text: 'Member of Record', value: 'user_id', width: '300px', primaryKey: true, },
                { text: 'Dues', value: 'dues', width: '100px', sortBy: 1, sortDir: 'desc' },
                { text: 'Violations', value: 'violations', width: '100px', sortBy: 2, sortDir: 'desc' },
                { text: 'Rentals', value: 'rentals', width: '100px', sortBy: 3, sortDir: 'desc' },
              ],
              itemTemplate: {
                user_id: {
                  label: 'Member of Record',
                  type: 'autocomplete',
                  itemsEndpoint: '/users/list/members',
                },
                dues: {
                  label: 'Dues',
                  type: 'currency',
                },
                violations: {
                  label: 'Violations',
                  type: 'currency',
                },
                rentals: {
                  label: 'Rentals',
                  type: 'currency',
                },
              },
              allowDblClickEdit: false,
              allowAdd: false,
              allowEdit: false,
              allowDelete: false,
              allowDownload: true,
              allowCopy: true,
              allowSearch: true,
              allowSort: true,
            },
          },
          {
            path: 'email',
            component: EmailCampaign,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Email Campaign`
            },
          },
          {
            path: 'email-lists',
            component: CrudBrowser,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Email Lists`
            },
            props: {
              title: 'Email List',
              crudRoute: '/email_list',
              headers: [
                { text: 'ID', value: 'id', width: '50px', primaryKey: true, sortBy: 1, sortDir: 'desc' },
                { text: 'Name', value: 'name', width: '200px' },
                { text: 'Default', value: 'default', width: '50px' },
                { text: 'Send to All User Emails', value: 'send_to_all', width: '80px' },
              ],
              itemTemplate: {
                id: {
                  type: 'number',
                  hidden: true
                },
                name: {
                  type: 'string',
                  required: true,
                },
                default: {
                  type: 'switch',
                  text: {
                    true: 'Subscribed',
                    false: 'Unsubscribed',
                  },
                  required: true,
                },
                send_to_all: {
                  type: 'switch',
                  text: {
                    true: 'Yes',
                    false: 'No',
                  },
                  required: true,
                }
              },
              allowDblClickEdit: false,
              allowAdd: true,
              allowEdit: true,
              allowDelete: true,
              allowDownload: true,
              allowCopy: true,
              allowSearch: true,
              allowSort: true,
            },
          },
          {
            path: 'resend-activation',
            component: ResendActivation,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Resend Activation`
            },
          },
          {
            path: 'reset-login-attempts',
            component: ResetLoginAttempts,
            meta: {
              title: `${process.env.VUE_APP_SHORT_TITLE} | Reset Login Attempts`
            },
          },
        ],
      },
    ],
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
